import React from "react";
import ContestCard from "../components/ContestCard";
import LoadingIux from "../../../../components/loading";
import { getContest } from "../../../../api/contest";
import ContestHeader from "../components/ContestHeader";
import "./NewEvents.css";

const NewEvent = () => {
  const [data, setData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const [hasMore, setHasMore] = React.useState(true);

  const observerRef = React.useRef();
  const loadingRef = React.useRef(null);

  const fetchContests = async () => {
    try {
      const response = await getContest({ status: "opening", page });
      const newData = response.data.data || [];
      setData((prevData) => [...prevData, ...newData]);
      setHasMore(newData.length > 0);
    } catch (error) {
      console.error("Error fetching contests:", error);
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    fetchContests();
  }, [page]);

  React.useEffect(() => {
    const options = {
      root: null,
      rootMargin: "20px",
      threshold: 0.1,
    };

    observerRef.current = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting && !isLoading && hasMore) {
        setPage((prevPage) => prevPage + 1);
      }
    }, options);

    if (loadingRef.current) {
      observerRef.current.observe(loadingRef.current);
    }

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [isLoading, hasMore]);

  return (
    <>
      <ContestHeader />
      <div
        className="new-events-cards"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {data?.length === 0 && !isLoading && (
          <div
            style={{
              color: "#A3A3A3",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "300px",
              flexDirection: "column",
            }}
          >
            <img
              src="/assets/images/icons/imageNotFound.png"
              style={{ width: "52px", height: "52px" }}
              alt=""
            />
            <div style={{ fontWeight: "800" }}>No Data</div>
            <div style={{ fontSize: "12px" }}>Description</div>
          </div>
        )}
      </div>
      <div
        className="new-events-cards"
        style={{ display: "grid", gap: "24px" }}
      >
        {data?.map((data) => (
          <ContestCard
            key={data.id}
            data={data}
            size="vertical"
            accountNumber={data.account_type_id}
          />
        ))}
      </div>
      {(isLoading || hasMore) && (
        <div
          ref={loadingRef}
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <LoadingIux />
        </div>
      )}
    </>
  );
};

export default NewEvent;
